import { useContext } from 'react'
import { useSelector } from 'react-redux'
import { FormattedMessage, defineMessages } from 'react-intl'
import { AmplitudeContext } from '@homebot/shared-util-quartermaster'

// Components
import { Text } from '../../../..'

// Contexts
import { useTheme } from '@homebot/shared-ui-swashbuckle'

// Selectors
import { selectShouldYouSellVideoThumbnail } from '../../../../../store/selectors/videos'
import { selectPositiveIndicatorsCount } from '../../../../../store/selectors/shouldYouSell'

// Utils
import { OVERLAY_HELPERS } from '../../../../../constants/navigation'
import { SHOULD_YOU_SELL_WIN } from '../../../../../constants/wins'
import ImportantNowCard from '../../ImportantNowCard'

// Assets
import DefaultThemeSvg from './DefaultThemeSvg'
import LightThemeSvg from './LightThemeSvg'

const newHomeMessages = defineMessages({
  nav: {
    id: 'ImportantNow.newHome.nav',
    defaultMessage: '\u25b6 Watch video',
  },
})

const ShouldYouSell = () => {
  const positiveIndicatorsCount = useSelector(selectPositiveIndicatorsCount)
  const videoThumbnailUrl = useSelector(selectShouldYouSellVideoThumbnail)
  const { theme } = useTheme()
  const { ampli } = useContext(AmplitudeContext)

  const Svg = theme.isLightThemeType ? LightThemeSvg : DefaultThemeSvg

  return (
    <ImportantNowCard
      name='ShouldYouSell'
      event={() => ampli?.winClicked({ win_type: SHOULD_YOU_SELL_WIN })}
      svgImage={Svg}
      navTo={OVERLAY_HELPERS.shouldYouSell.buildPath()}
      imageUrl={videoThumbnailUrl}
      navMessage={videoThumbnailUrl && newHomeMessages.nav}
    >
      <FormattedMessage
        id='ImportantNow.spotlight.shouldYouSell'
        defaultMessage='Thinking of selling? You have {num} strong selling signals'
        values={{
          num: (
            <Text
              element='span'
              weight='semibold'
              variant='neutralCool'
              variantCount='900'
            >
              {positiveIndicatorsCount}
            </Text>
          ),
        }}
      />
    </ImportantNowCard>
  )
}

ShouldYouSell.propTypes = {}

export default ShouldYouSell
